import React from 'react';
import { Section } from './Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section darker className="border-t border-gold-500/10" data-id="element-178">
      <div className="max-w-3xl mx-auto text-center bg-gradient-to-b from-navy-800 to-navy-900 p-5 md:p-12 rounded-2xl md:rounded-3xl border border-gold-500/30 shadow-[0_0_50px_rgba(212,168,67,0.1)]" data-id="element-179">
        <ShieldCheck className="w-12 h-12 md:w-20 md:h-20 text-gold-500 mx-auto mb-3 md:mb-6" data-id="element-180" />
        <h2 className="text-xl md:text-4xl font-heading font-bold text-white mb-4 md:mb-6" data-id="element-181">
          ✨ GARANTÍA PROFE DE VOLLEY RESUELTO — 7 DÍAS
        </h2>

        <div className="space-y-2 md:space-y-4 text-sm md:text-lg text-gray-300 mb-4 md:mb-8" data-id="element-182">
          <p data-id="element-183">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu entrenamiento
            si querés.
          </p>
          <p className="font-bold text-white text-base md:text-xl" data-id="element-184">
            Si en 7 días no es lo que esperabas: Te devolvemos el 100%.
          </p>
          <p data-id="element-185">Sin preguntas. Sin formularios. Sin drama.</p>
        </div>

        <p className="text-xs md:text-sm text-gray-400 mb-4 md:mb-6" data-id="element-186">
          La confianza que tenemos en Profe de Volley Resuelto™ nos permite
          hacer esa promesa sin dudar. Más de 300 profes de volley de todo el
          país ya lo saben.
        </p>

        <div className="inline-block bg-green-500/10 text-green-400 font-bold px-4 py-1.5 md:px-6 md:py-2 rounded-full border border-green-500/20 text-xs md:text-base" data-id="element-187">
          Tasa de devoluciones menor al 1%
        </div>
      </div>
    </Section>;
}